/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

const EVENT__EVENT_NAMES = {
  VIEW_CONTENT: 'ViewContent',
  CONTACT: 'Contact',
}

export default ($axios: any): any => ({
  EVENT__EVENT_NAMES,

  async event(params:{
    // FacebookAds 기본 요청값
    eventName: typeof EVENT__EVENT_NAMES[keyof typeof EVENT__EVENT_NAMES];
    sourceUrl:string; // 전체 주소(window.location.href)
    fbp?: string; // MetaPixel에 의해 쿠키 자동 생성
    fbc?: string; // 클릭으로 들어올 경우(query에 fbclid 값이 있면 cookie에 자동 입력됨. https://...//landing/1?fbclid=IwAR2F4-dbP0l7Mn1IawQQGCINEz7PYXQvwjNwB_qa2ofrHyiLjcbCRxTDMgk)
    // 데이터 확보 가능한 경우 추가 전달값
    email?: string;
    phone?: string;
    name?: string; // 브랜드명
    // test할 경우
    testEventCode?: string;
  }) {
    let content_id = (new URL(params.sourceUrl).pathname).replace(/\//g, '.');
    if (content_id.startsWith('.') && content_id.length > 1) {
      content_id = content_id.slice(1);
    }

    return camelize(await $axios.post("/facebook-ads/event", snakelize({
      ...params,
      content_id,
    })))
  },
})
